import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=070ea8be&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070ea8be')) {
      api.createRecord('070ea8be', component.options)
    } else {
      api.reload('070ea8be', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=070ea8be&", function () {
      api.rerender('070ea8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckylogin/Index.vue"
export default component.exports